import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { DocksPerTypologyItemMaintenanceDto } from './DocksPerTypologyItemMaintenanceDto';
import { DocksPerTypologyListMaintenanceDto } from './DocksPerTypologyListMaintenanceDto';


@Injectable()
export class DocksPerTypologySubMaintenanceController extends BaseSubMaintenanceController<DocksPerTypologyListMaintenanceDto, DocksPerTypologyItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router, "address/dockspertypology");
    }

    public getResourceRoot(): string {
        return "DOCKSPERTYPOLOGY";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/activity/address/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}
